<template>
  <section class="left-video-wall">
    <div class="video-grid">
      <div
        v-for="item in videos"
        :key="item.title"
        class="left-video-trigger"
        role="button"
        tabindex="0"
        :class="{ disabled: !item.iframeSrc }"
        @click="openVideo(item)"
        @keydown.enter.prevent="openVideo(item)"
        @keydown.space.prevent="openVideo(item)"
      >
        <MonitorVideoCard
          :title="item.title"
          :src="item.src"
          :type="item.type"
          :poster="item.poster"
          :cameras="item.cameras"
          lazy
        />
      </div>
    </div>
    <MonitorStatsRail :stats="stats" />
  </section>
  <popBg
    v-if="popShow && currentVideo"
    :title="currentVideo.title"
    :code="currentVideo.code"
    :popShow="popShow"
    @hiddlen="closeVideo"
  >
    <div class="ys-iframe-wrap">
      <iframe
        :src="currentIframeSrc"
        width="100%"
        height="100%"
        allowfullscreen
      ></iframe>
    </div>
  </popBg>
</template>

<script setup>
import { computed, ref } from "vue";
import popBg from "@/components/popBg.vue";
import MonitorStatsRail from "./MonitorStatsRail.vue";
import MonitorVideoCard from "./MonitorVideoCard.vue";

defineProps({
  videos: {
    type: Array,
    required: true,
  },
  stats: {
    type: Array,
    required: true,
  },
});

const popShow = ref(false);
const currentVideo = ref(null);
const accessToken = ref("");

const currentIframeSrc = computed(() => {
  if (!currentVideo.value) return "";
  return `${currentVideo.value.iframeSrc || ""}${accessToken.value || ""}`;
});

function openVideo(video) {
  if (!video.iframeSrc) return;
  currentVideo.value = video;
  accessToken.value = localStorage.getItem("AccessToken") || "";
  popShow.value = true;
}

function closeVideo() {
  popShow.value = false;
  currentVideo.value = null;
}
</script>

<style lang="less" scoped>
.left-video-wall {
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 26px 80px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 585px;
  gap: 30px;
  border: 2px solid rgba(72, 223, 210, 0.42);
  background:
    radial-gradient(circle at 50% 0, rgba(54, 255, 232, 0.12), transparent 42%),
    linear-gradient(180deg, rgba(1, 42, 39, 0.78), rgba(1, 20, 22, 0.94));
  box-shadow: inset 0 0 50px rgba(0, 255, 218, 0.16);
}

.video-grid {
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 34px 60px;
  padding: 26px 26px  26px 0;
}

.left-video-trigger {
  width: 100%;
  height: 100%;
  min-height: 0;
  cursor: pointer;
}

.left-video-trigger.disabled {
  cursor: default;
}

.left-video-trigger :deep(.monitor-video-card) {
  pointer-events: none;
}

.ys-iframe-wrap {
  width: 100%;
  height: 100%;
}

.ys-iframe-wrap iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
